module.exports = __webpack_public_path__ + "img/invite_rule_title.9479326b.png";